import {
  getSessionItem,
  setSessionItem,
} from '@/core/services/session-storage/session-storage';

export const CART_RETURN_PATH_STORAGE_KEY = 'mindoasisCartReturnPath';

const EXCLUDED_PATH_PREFIXES = ['/cart', '/checkout', '/configurator'] as const;

/**
 * Paths that are valid "back to shopping" destinations for the cart.
 * Excludes cart, checkout, and configurator so back skips those funnels.
 */
export function isCartReturnPath(pathname: string): boolean {
  if (!pathname.startsWith('/')) {
    return false;
  }

  return !EXCLUDED_PATH_PREFIXES.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function getCartReturnPath(): string | null {
  const path = getSessionItem(CART_RETURN_PATH_STORAGE_KEY);
  if (!path || !isCartReturnPath(path)) {
    return null;
  }
  return path;
}

export function setCartReturnPath(pathname: string): void {
  if (!isCartReturnPath(pathname)) {
    return;
  }
  setSessionItem(CART_RETURN_PATH_STORAGE_KEY, pathname);
}

/** Resolved href for the cart "back to shopping" button. */
export function resolveCartBackHref(): string {
  return getCartReturnPath() ?? '/';
}
